import {AgGridVue} from "ag-grid-vue";
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";
import vSelect from "vue-select";
import CellRendererCheckPickup from "@/components/optimization/upload-file/cell-renderer/CellRendererCheckPickup.vue";
import CellRendererCheckDelivery from "@/components/optimization/upload-file/cell-renderer/CellRendererCheckDelivery.vue";
import CellRendererActions from "@/components/optimization/upload-file/cell-renderer/CellRendererActions.vue";

window.numberParser = function numberParser(params) {
	return Number(params.newValue) | 0;
};

export const uploadFileVisitPoinList = {
	name: "UploadFileVisitPoinList",
	props: {
		customConfig: {
			type: Object,
			default: () => {
				return {
					rowSelection: "multiple",
					activeCheckbox: false,
					columns: [],
					tableOptions: true,
					showItemsPerPage: true,
					showPopup: false,
					showMaximizeBtn: false,
					showActions: false,
				};
			},
		},
		maximize: {
			type: Boolean,
			default: true,
		},
		isHeightMedium: {
			type: Boolean,
			default: false,
		},
	},
	components: {
		AgGridVue,
		vSelect,
		CellRendererCheckPickup,
		CellRendererCheckDelivery,
		CellRendererActions,
	},
	data() {
		return {
			currentPageLocal: 1,
			quantityElementPage: 3,
			gridApi: null,
			gridOptions: {},
			pagination: {
				next_page: 0,
				total_pages: 0,
				total_records: 0,
			},
			defaultColDef: {
				sortable: true,
				resizable: true,
				suppressMenu: true,
			},
			components: {
				CellRendererCheckPickup,
				CellRendererCheckDelivery,
				CellRendererActions,
			},
		};
	},
	watch: {
		totalVisitPointChecked(val) {
			if (val >= 2) {
				this.$vs.notify({
					color: "success",
					title: this.$t("UploadFiles.SelectFile"),
					text: this.$t("TheMaximumFileSelectionPickup"),
					time: 5000,
				});
			}
		},
		totalVisitPointCheckedDelivery(val) {
			if (val >= 2) {
				this.$vs.notify({
					color: "success",
					title: this.$t("UploadFiles.SelectFile"),
					text: this.$t("TheMaximumFileSelectionDelivery"),
					time: 5000,
				});
			}
		},
	},
	computed: {
		overlayLoadingTemplate() {
			return `<div class="ring">${this.$t("Loading")}<span></span></div>`;
		},
		overlayNoRowsTemplate() {
			return `<span style="font-size: 14px; font-weight: 500; color: grey">${this.$t("NoDataAvailable")}</span>`;
		},
		columnDefs() {
			let columns = [
				{
					headerName: this.$t("PICKUP"),
					field: "isPickup",
					width: 117,
					headerTooltip: this.$t("PICKUP"),
					cellRendererFramework: "CellRendererCheckPickup",
					sortable: false,
				},
				{
					headerName: this.$t("DELIVERY"),
					field: "isDelivery",
					width: 110,
					headerTooltip: this.$t("DELIVERY"),
					cellRendererFramework: "CellRendererCheckDelivery",
					sortable: false,
				},
				{
					headerName: "Path",
					field: "bucket_path",
					width: 650,
				},
				{
					headerName: this.$t("ResourceModule.Table.Actions"),
					field: "transactions",
					width: 120,
					cellRendererFramework: "CellRendererActions",
					pinned: "right",
				},
			];
			const showColumns =
				this.customConfig.columns !== undefined && this.customConfig.columns.length > 0
					? this.customConfig.columns
					: [];
			if (showColumns.length > 0) {
				columns = columns.filter((column) => {
					if (showColumns.includes(column.field)) {
						return column;
					}
				});
			}
			return columns;
		},
		paginationPageSize() {
			if (this.pagination.total_records > 0) {
				return this.pagination.total_records;
			} else {
				return 0;
			}
		},
		totalPages() {
			if (this.pagination.total_pages > 0) return this.pagination.total_pages;
			else return 0;
		},
		currentPage: {
			get() {
				return this.currentPageLocal;
			},
			set(val) {
				this.currentPageLocal = val;
			},
		},
		usersData() {
			return this.$store.state.moduleVisitPoint.uploadFileVisitPointsOptimization === undefined ||
				this.$store.state.moduleVisitPoint.uploadFileVisitPointsOptimization === "" ||
				this.$store.state.moduleVisitPoint.uploadFileVisitPointsOptimization === null
				? []
				: this.$store.state.moduleVisitPoint.uploadFileVisitPointsOptimization;
		},
		getCheckedVisitPointsPickup() {
			return this.$store.state.moduleVisitPoint.checkedUploadFileVisitPoitsPickup === undefined ||
				this.$store.state.moduleVisitPoint.checkedUploadFileVisitPoitsPickup === "" ||
				this.$store.state.moduleVisitPoint.checkedUploadFileVisitPoitsPickup === null
				? []
				: this.$store.state.moduleVisitPoint.checkedUploadFileVisitPoitsPickup;
		},
		getCheckedVisitPointsDelivery() {
			return this.$store.state.moduleVisitPoint.checkedUploadFileVisitPoitsDelivery === undefined ||
				this.$store.state.moduleVisitPoint.checkedUploadFileVisitPoitsDelivery === "" ||
				this.$store.state.moduleVisitPoint.checkedUploadFileVisitPoitsDelivery === null
				? []
				: this.$store.state.moduleVisitPoint.checkedUploadFileVisitPoitsDelivery;
		},
		totalVisitPointChecked() {
			let totalChecked =
				this.getCheckedVisitPointsPickup && this.getCheckedVisitPointsPickup.length > 0
					? this.getCheckedVisitPointsPickup.length
					: 0;
			return totalChecked;
		},
		totalVisitPointCheckedDelivery() {
			let totalChecked =
				this.getCheckedVisitPointsDelivery && this.getCheckedVisitPointsDelivery.length > 0
					? this.getCheckedVisitPointsDelivery.length
					: 0;
			return totalChecked;
		},
		windowWidth() {
			return this.$store.state.windowWidth;
		},
		isWidthPortatil() {
			return window.innerWidth <= 1366;
		},
	},
	methods: {
		onBtShowLoading() {
			this.gridApi.showLoadingOverlay();
		},
		onBtHide() {
			this.gridApi.hideOverlay();
		},
		setColumnFilter(column, val) {
			const filter = this.gridApi.getFilterInstance(column);
			let modelObj = null;
			if (val !== "all") {
				modelObj = {type: "equals", filter: val};
			}
			filter.setModel(modelObj);
			this.gridApi.onFilterChanged();
		},
		resetColFilters() {
			this.gridApi.setFilterModel(null);
			this.gridApi.onFilterChanged();
		},
		updateSearchQuery(val) {
			this.gridApi.setQuickFilter(val);
		},
		paginationSetPageSize(num) {
			this.gridApi.paginationSetPageSize(num);
			this.quantityElementPage = num;
		},
	},
	mounted() {
		this.gridApi = this.gridOptions.api;
	},
	created() {
		this.tooltipShowDelay = 500;
	},
};
